/**
 * @license
 * Copyright Tyler Technologies, Inc. 
 * License: Apache-2.0
 */
import { COMPONENT_NAME_PREFIX } from '../../constants';
const elementName = `${COMPONENT_NAME_PREFIX}option-group`;
const attributes = {
    LABEL: 'label'
};
export const OPTION_GROUP_CONSTANTS = {
    elementName,
    attributes
};
